import { Link } from "gatsby"
import React, { useState } from "react"

const Project = image => {
  const [isVisible, setIsVisible] = useState(false)

  const { img, title, text } = image

  return (
    <div className="relative cursor-pointer">
      <Link
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onTouchStart={() => setIsVisible(true)}
        onTouchEnd={() => setIsVisible(false)}
        to={title.toLowerCase()}
      >
        <img className="m-0" src={img} alt={title} />
        {isVisible && (
          <div className="absolute flex flex-col w-full bg-black bg-opacity-80 bottom-0 text-white pl-[41px] pt-[21px] pb-[30px]">
            <h3 className="m-0 mb-[10px] font-playfair font-black text-[36px]">
              {title}
            </h3>
            <span className="flex w-[94%] font-ubuntu text-[16px] font-light">
              {text}
            </span>
          </div>
        )}
      </Link>
    </div>
  )
}

export default Project
